import { render, staticRenderFns } from "./BotSelect.vue?vue&type=template&id=52f1716c"
import script from "./BotSelect.vue?vue&type=script&lang=ts"
export * from "./BotSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports